/*
 * @Author: Zhouqi
 * @Date: 2025-10-29 17:19:50
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-09 15:37:13
 */
import { message } from 'antd';

import UserStore from '@/store/User';
import { EventNewID, SubscriptionTypeEnum } from '@/utils/eventlog/eventNewConfig';
import { trackEvent } from '@/utils/eventlog/logAdapter';

import CommonModal from '..';
import { PaymentContentUS, PaymentModalProps } from './us';

export async function paymentModalShow(options: PaymentModalProps) {
  const { feature, reason } = options;
  trackEvent(EventNewID.SUBSCRIPTION_POP_EXP, {
    subscribe_type: SubscriptionTypeEnum.plan,
    source: feature,
    reason,
  });
  const hide = message.loading('', 0);
  try {
    await UserStore.getState().getCouponInfo();
  } finally {
    hide();
  }
  let destroyRef = {
    current: () => {},
  };
  CommonModal.show((t) => ({
    width: '100vw',
    footer: false,
    customPadding: {
      x: 0,
      y: 0,
    },
    modalClassName: 'payment-modal',
    content: (close) => (
      <PaymentContentUS
        {...options}
        t={t}
        destroyRef={destroyRef}
        onClose={() => {
          close();
          options.onClose?.();
        }}
      />
    ),
  }));
}
